import script from "./IndexLearning.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexLearning.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__